import { TieredMenu } from "primereact/tieredmenu";
import { useCallback } from "react";
import { IconDispatcher } from "shared/Icons";
import '../editor.scss';

export const InsertOptions = ({ editor, insertRef, handleshow }) => {


    const handleInsertChange = (attribute, event) => {
        if(event){
            event.preventDefault()
        }
        switch (attribute) {
            case 'bulletList':
                editor.chain().focus().toggleBulletList().run();
                break;
            case 'orderedList':
                editor.chain().focus().toggleOrderedList().run();
                break;
            case 'taskList':
                editor.chain().focus().toggleTaskList().run();
                break;

            case 'blockquote':
                editor.chain().focus().toggleBlockquote().run()
                break;
            case 'horizontalRule':

                editor.chain().focus().setHorizontalRule().run();
                return;
            default:
                break;
        }
        handleshow(event, 'insert')

    };

    const isActive = useCallback((type, att) => {
        if (typeof type === 'object') {
            const isActive = type.map(t => editor.isActive(t)).filter(Boolean)
            return isActive.length ? 'is-active' : ''

        }
        if (att) return editor.isActive(type, att) ? 'is-active' : ''
        return editor.isActive(type) ? 'is-active' : ''
    }, [editor])

    const iconActive = useCallback(() => {
        if (isActive('bulletList')) return 'list-ul'
        if (isActive('orderedList')) return 'list-ol'
        if (isActive('taskList')) return 'list-check'
        if (isActive('blockquote')) return 'block-quote'

        return 'list-ul'

    }, [isActive])

    if (!editor) {
        return null
    }

    const items = [
        { label: "bullet list", icon: 'list-ul', text: 'Bullet List', attribute: 'bulletList' },
        { label: "ordered list", icon: 'list-ol', text: 'Numbered List', attribute: 'orderedList' },
        { label: "task list", icon: 'list-check', text: 'Task List', attribute: 'taskList' },
        { separator: true },
        { label: "blockquote", icon: 'block-quote', text: 'Quote', attribute: 'blockquote' },
        { label: "horizontal rule", icon: 'horizontal-rule', text: 'Horizontal Rule', attribute: 'horizontalRule' },

    ];


    const templates = items.map(item => (item.separator ? item : {
        template: (
            <div
                key={item.label}
                onClick={(e) => handleInsertChange( item.attribute, e)}
                className={isActive(item.attribute) + 'pointer p-2 px-4'}
                style={{ minWidth: '200px' }}

            >
                {IconDispatcher(item.icon, "me-2", { family: 'sharp' })} {item.text}
            </div>
        )
    }));

    const icon = iconActive()
    return (
        <>
            <TieredMenu model={templates} popup ref={insertRef} breakpoint="767px" className='menu-color-toolbar ' />
            <button
                key={icon}
                title='Insert'
                className={isActive(['bulletList', 'orderedList',"taskList","blockquote","horizontalRule"]) + " d-flex justify-content-center align-items-center"}

                onClick={(e) => {
                    e.preventDefault()
                    handleshow(e, 'insert')
                }}
            >
                {IconDispatcher(icon, "", { family: 'sharp' })} {IconDispatcher('angle-down', "ms-1", { size: "sm" })}
            </button>
        </>
    );

};